// Blocked words for content moderation
// Categories: expletives, slurs, violence, sexual content, self-harm
export const BLOCKED_WORDS = [
  // Common expletives
  'fuck', 'shit', 'bitch', 'ass', 'asshole', 'bastard', 'dick', 'cock', 'pussy', 'cunt', 'fag', 'faggot', 'whore', 'slut', 'douchebag', 'prostitute',
  
  // Racial slurs (partial list - add specific terms as needed)
  'nigger', 'nigga', 'chink', 'gook', 'wetback', 'spic', 'kike', 
  'raghead', 'towelhead', 'beaner',
  
  // Homophobic/transphobic slurs
  'tranny', 'shemale', 'dyke', // note: 'queer' is reclaimed by some, consider context
  
  // Violence & harm
  'kill', 'murder', 'suicide', 'rape', 'molest', 'abuse', 'stab', 'shoot', 'bomb', 'terrorist', 'assault',
  'kidnap', 'torture', 'strangle', 'choke',
  
  // Sexual content
  'porn', 'sex', 'nude', 'penis', 'vagina',
  'anal', 'oral', 'blowjob', 'handjob', 'masturbate', 'orgasm',
  
  // Self-harm
  'suicide', 'kill myself', 'end it all', 'cut myself', 'self harm',
  'overdose', 'hang myself',
  
  // Hate speech
  'nazi', 'hitler', 'genocide', 'lynch', 'kkk', 'white power', 'trump', 'biden', 'republican', 'democrat', 'kamala', 
  
  // Drug references (optional - you decide)
  'cocaine', 'heroin', 'meth', 'crack', 'weed', 'marijuana', 
  
  // Scam/spam indicators
  'click here', 'buy now', 'limited time', 'act fast', 'crypto invest'
];

// Check if text contains blocked words
export const containsBlockedWords = (text) => {
  const normalizedText = text.toLowerCase().trim();
  
  // Check for exact word matches (with word boundaries)
  for (let word of BLOCKED_WORDS) {
    // Create regex with word boundaries to avoid false positives
    // e.g., "assume" won't trigger "ass"
    const regex = new RegExp(`\\b${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
    if (regex.test(normalizedText)) {
      return {
        blocked: true,
        word: word
      };
    }
  }
  
  return {
    blocked: false,
    word: null
  };
};

// Get a user-friendly error message
export const getBlockedWordMessage = () => {
  return "Your question contains inappropriate content. Please keep questions respectful and family-friendly.";
};